import cn from 'clsx'

import styles from './DocumentsMenuLabel.module.scss'

interface DocumentsMenuLabelProps {
  number: number | string
  label: string
}

export default function DocumentsMenuLabel({
  number,
  label,
}: DocumentsMenuLabelProps) {
  const hasSubNumber = String(number).includes('.')

  return (
    <>
      <span className={cn(styles.root, hasSubNumber && styles.root_sub)}>
        {number}
      </span>
      {label}
    </>
  )
}
